import { Props_SnippetContent } from './Content.props'
import { CompileHeadingToSpan, CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetContent = (props: Props_SnippetContent) => {
    const { heading, repeatable_link, paragraph, eyebrow, background } = props
    
    const classHeadingVisibility: string = heading.visibility.value ? `` : 'accessible-heading'
    const classBackground: string = background?.color?.value ? `snippet-content--${background.color.value}` : ''

    return (
        <section className={`snippet-content ${classBackground}`}>
            <div className="snippet-content__container">
                <h2 className={`snippet-content__heading ${classHeadingVisibility}`}>
                    {CompileHeadingToSpan(heading.text?.value || '')}
                </h2>
                {!!eyebrow?.text?.value && <div className="snippet-content__eyebrow">{CompileMarkdown(eyebrow.text.value)}</div>}
                {!!paragraph.text?.value && <div className="snippet-content__content">{CompileMarkdown(paragraph.text.value)}</div>}
                <div className="snippet-content__link-container">
                    {repeatable_link.map((link, index) => (
                        <SnippetLink
                            key={index}
                            className="snippet-content__link"
                            url={link.linkHref?.value}
                            linkStyles={link.linkStyle?.value}
                            openInNewTab={link.linkTarget?.value}
                        >
                            {link.linkText?.value}
                        </SnippetLink>
                    ))}
                </div>
            </div>
        </section>
    )}

export default SnippetContent
